// extracted by mini-css-extract-plugin
module.exports = {"login":"style__login__gix94","activationForm":"style__activationForm__CWbHO"};